/* eslint no-template-curly-in-string: "off" */

import jetblueLogo from '../../../../assets/images/true-blue-blue-on-white.jpg';
import { FLOW_TYPES } from "../../../../utils/enums";

export const jetblueTravelBank = {
  id: "JETBLUE_TRAVEL_BANK",
  displayName: "JetBlue Travel Bank",
  paywall: {
    tile: {
      displayName: "JetBlue Travel Bank",
      tagline: ["Reciba una bonificación del 25%"],
      description: [
        {
          string: "Disponible en su cuenta de JetBlue Travel Bank",
          type: "div",
        },
        {
          string: "en un plazo de 3 días hábiles",
          type: "div"
        }
      ],
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.FORM,
    form: {
      title: "Crédito de Viaje de JetBlue",
      description: "Por favor, introduzca los datos siguientes para recibir su pago.",
      jsonFormProps: {
        schema: {
          type: "object",
          required: ["createTrueBlueAccount"],
          properties: {
            createTrueBlueAccount: {
              type: "boolean",
              title: "¿Tiene una cuenta vigente de TrueBlue?",
              default: true,
              enumNames: [
                "No, por favor, creen una para mí.",
                "Sí, tengo un número de cuenta existente."
              ]
            }
          },
          dependencies: {
            createTrueBlueAccount: {
              oneOf: [
                {
                  required: ["emailAddress"],
                  properties: {
                    emailAddress: {
                      type: "string",
                      title:
                        "Dirección de correo electrónico que será asociada a su nueva cuenta de TrueBlue",
                      format: "email"
                    },
                    createTrueBlueAccount: { enum: [true] }
                  }
                },
                {
                  required: ["emailAddress", "trueBlueNumber"],
                  properties: {
                    emailAddress: {
                      type: "string",
                      title: "Dirección de Correo Electrónico de TrueBlue",
                      format: "email"
                    },
                    trueBlueNumber: {
                      type: "string",
                      title: "Número de Cuenta de TrueBlue",
                      pattern: "^\\d*$",
                      maxLength: 10,
                      minLength: 10
                    },
                    createTrueBlueAccount: { enum: [false] }
                  }
                }
              ]
            }
          }
        },
        formData: { emailAddress: "${payment.recipientEmail}" },
        uiSchema: {
          emailAddress: {
            "ui:widget": "email",
            classNames: "json-form-field"
          },
          trueBlueNumber: { classNames: "json-form-field" },
          createTrueBlueAccount: {
            "ui:widget": "radio",
            classNames: "json-form-field"
          }
        }
      },
      validationErrors: {
        trueBlueNumber: {
          type: "Los números de cuenta de TrueBlue deben constar de 10 dígitos numéricos",
          pattern: "Los números de cuenta de TrueBlue deben constar de 10 dígitos numéricos",
          maxLength: "Los números de cuenta de TrueBlue deben constar de 10 dígitos numéricos",
          minLength: "Los números de cuenta de TrueBlue deben constar de 10 dígitos numéricos"
        }
      },
      filterFieldsByValue: [
        {
          expectedValues: { createAccount: true },
          fieldsToInclude: ["createTrueBlueAccount", "emailAddress"]
        },
        {
          expectedValues: { createAccount: false },
          fieldsToInclude: [
            "createTrueBlueAccount",
            "emailAddress",
            "trueBlueNumber"
          ]
        }
      ]
    }
  },
  acceptPayment: {
    description: [
      "Ha elegido recibir ",
      {
        string: "${payment.amount}",
        props: {
          className: 'payment-amount',
        },
        transformations: [
          {
            "type": "removeCurrencyFormatting"
          },
          {
            "type": "multiply",
            "config": {
              "multiplier": 1.25
            }
          },
          {
            "type": "ceil"
          },
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ]
      },
      " (",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " más la bonificación del 25%) a su cuenta ",
      {
        string: "TrueBlue™ de JetBlue",
        props: {
          className: 'payment-paymentNetwork'
        }
      },
      "."
    ],
    imgSrc: jetblueLogo
  },
  paymentComplete: {
    imgSrc: jetblueLogo,
    initial: {
      description: [
        "¡Éxito! Enviamos ",
        {
          string: "${payment.amount}",
          props: {
            className: 'payment-amount',
          },
          transformations: [
            {
              "type": "removeCurrencyFormatting"
            },
            {
              "type": "multiply",
              "config": {
                "multiplier": 1.25
              }
            },
            {
              "type": "ceil"
            },
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.currency}"
              }
            }
          ]
        },
        " (",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
        },
        " más la bonificación del 25%) a su cuenta ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        "."
      ],
    },
    revisit: {
      description: [
        "El ",
        {
          string: "${payment.updatedAt}",
          transformations: [
            {
              type: "formatDate"
            }
          ],
          props: {
            className: 'payment-updatedAt'
          }
        },
        ", enviamos ",
        {
          string: "${payment.acceptedAmount}",
          props: {
            className: 'payment-amount',
          },
          transformations: [
            {
              "type": "removeCurrencyFormatting"
            },
            {
              "type": "multiply",
              "config": {
                "multiplier": 1.25
              }
            },
            {
              "type": "ceil"
            },
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ]
        },
        " (",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
        },
        " más la bonificación del 25%) a su cuenta ",
        {
          string: "${paymentNetwork.displayName}",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        "."
      ],
    },
  }
};

export default jetblueTravelBank;
